// 客户性质
import AppConfig from "../../../config/AppConfig";

const CustomerClasses = {1: '个人客户', 2: '企业客户'}

// 客户类型
const CustomerTypes = {1: '业主', 2: '租户', 3: '住户', 4: '共有人', 5: '开发商', 9: '其它'}

export default {

  getBaseUrl() {
    // return 'http://www.zhoaoss.com/'
   return AppConfig.erp_server+"/"
    //return 'http://localhost/'
  },

  /**
   * 获取客户性质名称
   */
  getClassName(val) {
    return CustomerClasses[val]
  },

  /**
   * 获取客户类型名称
   */
  getTypeNames(val) {
    if(typeof val == 'string') val = val.split(',')
    let arr = []
    for(let k in CustomerTypes) {
      if(val.includes(k)) {
        arr.push(CustomerTypes[k])
      }
    }
    return arr
  },

  /**
   * 日期时间格式化
   */
  timeFormat(timestamp = 0, displayTime = true) {
  	let date = new Date(timestamp * 1000);
  	let year = date.getFullYear();
  	let month = ("0" + (date.getMonth() + 1)).slice(-2);
  	let sdate = ("0" + date.getDate()).slice(-2);
  	let hour = ("0" + date.getHours()).slice(-2);
  	let minute = ("0" + date.getMinutes()).slice(-2);
  	let second = ("0" + date.getSeconds()).slice(-2);
  	let result = year + "-" + month + "-" + sdate;
  	if(displayTime) result += " " + hour + ":" + minute + ":" + second
  	return result
  },

  /**
   * 根据日期算年龄
   */
  getAge(birthday) {
    if(birthday){
      birthday=birthday.split('-');
      // 新建日期对象
      let date = new Date();
      // 今天日期，数组，同 birthday
      let today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
      // 分别计算年月日差值
      let age = today.map((val, index) => {
          return val - birthday[index]
      })
      // 当天数为负数时，月减 1，天数加上月总天数
      if (age[2] < 0) {
          // 简单获取上个月总天数的方法，不会错
          let lastMonth = new Date(today[0], today[1], 0)
          age[1]--
          age[2] += lastMonth.getDate()
      }
      // 当月数为负数时，年减 1，月数加上 12
      if (age[1] < 0) {
          age[0]--
          age[1] += 12
      }
      return age[0]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Customer/common.js